import api from "../config/api";

export const getAllFixedRates = async () => {
  const res = await api.get("/fixedRate/");
  return res.data;
};

export const getAmountBySourceAndDestination = async (source_id, destination_id) => {
  const res = await api.get(`/fixedRate/?source_id=${source_id}&destination_id=${destination_id}`);
  return res.data;
};

export const bulkUpsertFixedRates = async (records) => {
  const payload = { records };
  console.log("Sending to backend:", { records });
  const res = await api.post("/fixedRate/", payload, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};


export const deleteFixedRate = async (id) => {
  const res = await api.delete(`/fixedRate/?id=${id}`);
  return res.data;
};
